var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconC3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.96,
    height: 64.96,
    viewBox: "0 0 64.96 64.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#0a53a6;stroke-width:2px;}.b{fill:#50b848;}.c{fill:#0a53a6;}.d{stroke:none;}.e3{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 32.48,
    cy: 32.48,
    r: 32.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e3",
    cx: 32.48,
    cy: 32.48,
    r: 31.48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.533 15.533)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8.879,
    cy: 8.879,
    r: 8.879,
    transform: "translate(13.898 13.898)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5746.434,2330.791c-.264-.258-.541-.505-.83-.738l1.6-1.6a7.7,7.7,0,0,0-10.891-10.891l-8.227,8.226-.009-.01-9.414,9.414a7.7,7.7,0,0,0,5.45,13.147,7.623,7.623,0,0,0,5.431-2.246l1.6-1.6a10,10,0,0,0,.753.844,10.291,10.291,0,0,0,13.932.575l.024.024.315-.326c.093-.086.184-.174.273-.263l.6-.6-.034-.034a10.3,10.3,0,0,0-.575-13.922m-8.945-12.049a6.021,6.021,0,1,1,8.515,8.515l-1.816,1.817a10.175,10.175,0,0,0-2.635-1.018l-.057-.013c-.116-.026-.229-.051-.346-.073l-.1-.018c-.1-.019-.2-.036-.3-.052l-.124-.018c-.1-.014-.192-.025-.287-.036l-.133-.014c-.1-.009-.189-.017-.283-.023l-.135-.01c-.1-.005-.194-.009-.291-.011l-.124,0c-.116,0-.231,0-.347,0h-.065q-.206,0-.411.017l-.121.01c-.095.007-.19.014-.284.024l-.168.02-.237.03c-.061.008-.121.018-.183.028l-.22.037-.19.037c-.07.014-.141.029-.21.044l-.194.044-.2.052-.194.052c-.067.019-.132.04-.2.06s-.132.04-.2.061-.127.043-.19.066-.133.045-.2.07-.116.046-.174.069c-.135.053-.269.109-.4.167-.054.024-.107.046-.161.071-.07.032-.139.067-.209.1l-.161.079c-.069.036-.137.073-.2.109l-.158.086c-.067.038-.134.078-.2.118l-.154.093-.2.126c-.05.033-.1.066-.149.1-.065.044-.13.089-.194.135-.049.035-.1.07-.146.106-.064.047-.127.094-.191.143l-.141.113c-.062.05-.125.1-.186.151l-.012.009-.02-.02-3.224-3.225Zm-9.125,26.165a6.017,6.017,0,0,1-8.5-8.515l8.225-8.226,3.235,3.254c-.01.01-.017.021-.026.032l-.009.011q-.138.165-.269.336l-.006.008a10.334,10.334,0,0,0-.829,11.283Zm4.732-.759a9.517,9.517,0,0,1-1.128-1.4l-.015.009-.005-.009,0-.007,0,0a8.641,8.641,0,0,1,.569-10.143l4.669,4.67h0l0,0,7.447,7.447a8.612,8.612,0,0,1-11.54-.569m5.286-8.061,0,0-4.666-4.666a8.642,8.642,0,0,1,10.136-.555l.087.057a8.515,8.515,0,0,1,1.3,1.061,8.61,8.61,0,0,1,.569,11.54Z",
    transform: "translate(-5716.407 -2315.31)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconC3);
export default __webpack_public_path__ + "static/media/icon-c-3.42b9645c.svg";
export { ForwardRef as ReactComponent };